export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8614.e9e93831.jpg";